<!-- TEMPLATE -->
<template>
  <div class="content-container">
    <dean-section-title secondary="true" sidemenuButton="true">
      <span slot="title">{{ title }}</span>
      <dean-section-title-item
        v-if="$store.getters.getUser.privileges.includes('change-status-quote')"
        :icon="trashIcon"
        @click.native="removeQuote"
        :content="true">
        verwijderen
      </dean-section-title-item>
    </dean-section-title>
    <dean-section-divider :sidemenu="true">
      {{ divider }}
    </dean-section-divider>
    <nav class="navigation">
      <ul class="mainmenu">
        <li v-for="(item, key) in services"
            @click="selectService(item)">
          <dean-icon
            :glyph="item.icon"
            width="18"
            height="18"
          ></dean-icon>
          <span>
            {{ item.name }}
          </span>
          <dean-icon
            v-if="!item.add && $store.getters.getUser.privileges.includes('change-status-quote')"
            class="icon-right"
            :glyph="forwardIcon"
            height="15"
            width="15">
          </dean-icon>
          <dean-icon
            v-if="item.add && $store.getters.getUser.privileges.includes('change-status-quote')"
            class="icon-right"
            :glyph="plusIcon"
            height="15"
            width="15">
          </dean-icon>
        </li>
      </ul>
    </nav>
    <transition name="fade" mode="out-in" style="position: absolute;" v-if="isLoading">
      <dean-load-overlay></dean-load-overlay>
    </transition>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { deanDialogBus } from '@/main';
import axios from 'axios';
import {
  deanIcon,
  plusIcon,
  deanButton,
  trashIcon,
  deanSectionTitle,
  deanSectionDivider,
  deanSectionTitleItem,
  forwardIcon,
  deanLoadOverlay,
} from '@deanone/dean-components';

@Component({
  components: {
    deanIcon,
    plusIcon,
    deanButton,
    trashIcon,
    deanSectionTitle,
    deanSectionDivider,
    deanSectionTitleItem,
    forwardIcon,
    deanLoadOverlay,
  },
})

export default class DeanMenu extends Vue {
  @Prop({ default: '' }) public service!: object;
  @Prop({ default: '' }) public quoteId: any;
  @Prop({ default: '' }) public divider: any;
  @Prop({ default: '' }) public title: any;
  public services: object = {} ;

  public trashIcon: object = trashIcon;
  public isLoading: boolean = false;
  public forwardIcon: object = forwardIcon;
  public plusIcon: object = plusIcon;
  private readonly baseUrl: string = '/-/trade/api/quote.service.list';

  // METHODS
  public selectService(service: string) {
    this.$emit('update', service);
  }

  public removeQuote() {
    deanDialogBus.$emit('open', 'QuoteRemoveDialog', {});
  }

  public mounted() {
    this.isLoading = true;
    axios.post(this.baseUrl, {
      quoteId: this.$route.params.id,
    }).then(
      (response) => {
        this.services = response.data;
        this.isLoading = false;
      },
      (error) => {
        // tslint:disable-next-line:no-console
        console.error(error);
        this.isLoading = false;
      },
    );
  }
}

</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.content-container {
  position: relative;

  :deep(.dean-tooltip) {
    fill: black;
    background: rgba(0, 0, 0, 0.2);
  }
}

.dean-section-divider.dean-section-divider-small {
  padding-left: 20px;
}

:deep(.dean-load-overlay) {
  position: absolute;
  min-height: calc(100vh - 80px);

  .dean-overlay {
    position: absolute;
  }
}

.column {
  width: 100%
}

.mainmenu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mainmenu li {
  transition: all ease 0.8s;
  display: block;
  height: 38px;
  border-bottom: 1px solid $color-secondary;
  background-color: #FFF;
  text-decoration: none;
  padding: 10px;
  margin: 10px 10px 0 10px;
  // color: $color-info;
  // fill: $color-info;

  .icon-right {
    position: relative;
    float: right;
    position: relative;
    margin: 2.5px 0px 2.5px 0px;
    fill: var(--color-dark-shade-4, $color-dark-shade-4);
  }
}

.mainmenu li span {
  margin-left: 30px;
}

.mainmenu li svg{
  position: absolute;
}

.mainmenu li:hover {
  cursor: pointer;
  background-color: $color-secondary;
}

</style>
